export default {
  title: 'General',
  logo: {
    rule: 'Authorized JPG, JPEG or PNG formats. Maximum logo size 800 KB '
  },
  club: {
    code: 'company code',
    name: 'company name',
    managerName: 'managers first and last name',
    address: 'Address',
    phoneNumber: 'Mobile Number',
    managerPhoneNumber: 'CEO Mobile Number'
  }
}
